import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_crntsyfkzr: FaireBrandEntity = {
  token: "b_crntsyfkzr",
  type: "brand",
  name: "J. Mack Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/5bba3968fe773b338d39cac27df0e3a70b1985417c02134db581f4e2888fd0fc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a408bce6737470c9cf4d67d96415d49872d2e8892a1887c578a82bea4a166e3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/5bba3968fe773b338d39cac27df0e3a70b1985417c02134db581f4e2888fd0fc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a408bce6737470c9cf4d67d96415d49872d2e8892a1887c578a82bea4a166e3.png",
  location: "Safety Harbor, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to J. Mack Designs! We are so happy you are here and supporting our business. We specialize in offering a beautiful collection of graphic tees and apparel that focus on faith, encouragement, empowerment, positivity and an overall happy vibes! All items you see are printed by us in the USA - specifically our headquarters in Florida.\n\nWe are family owned and operated and pride ourselves on unique designs, high quality and great customer service. This business means the world to us and we love being able to provide you with beautiful, empowering and high quality items to help your business stand out and bring a unique collection to your customers.\n\nYour support means the world to us. Thank you for being here, for supporting our business and family and for making our dreams come true. I am honored you are here and we cannot wait to create something special for you.\n\n-Meghan",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:33.974Z",
    importedBy: "entity-db-cli",
  },
};
